export default {
  meta: {
    title: '集客点-商圈地图',
  }
};
